import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Results from "./results";

const steps = [
  {
    id: "hair",
    label: "Cabello",
    coverImage:
      "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/BANNER-DIAGNOSTICO-CABELLO.jpg?v=1662574233",
    questions: [
      {
        text: "¿Cómo percibes tu cabello?",
        type: "radio",
        options: [
          {
            text: "Delgado",
            value: "detox",
            image:
              "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/FINO.png?v=1663555617",
          },
          {
            text: "Mediano",
            value: "reparacion",
            image:
              "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/MEDIANO.png?v=1663555616",
          },
          {
            text: "Grueso",
            value: "hidratacion",
            image:
              "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/GRUESO.png?v=1663555616",
          },
        ],
      },
      {
        text: "¿Cuál es la principal preocupación que tienes sobre tu <strong>cabello</strong>?<br/>Mínimo 1, máximo 3",
        type: "checkbox",
        options: [
          {
            text: "Seco",
            value: "reparacion",
          },
          {
            text: "Dañado",
            value: "reparacion",
          },
          {
            text: "Sin volumen",
            value: "reparacion",
          },
          {
            text: "Deshidratado",
            value: "hidratacion",
          },
          {
            text: "Difícil de peinar",
            value: "hidratacion",
          },
          {
            text: "Poco luminoso",
            value: "hidratacion",
          },
          {
            text: "Graso",
            value: "detox",
          },
          {
            text: "Pesado",
            value: "detox",
          },
          {
            text: "Parece sucio",
            value: "detox",
          },
          {
            text: "Nada, ¡todo me encanta!",
            value: "hidratacion",
          },
        ],
      },

    ],
  },
  {
    id: "face",
    label: "Rostro",
    coverImage:
      "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/BANNER-DIAGNOSTICO-ROSTRO_da3bc2f4-2ed2-420b-a20a-a0de6a281cc2.jpg?v=1663031772",
    questions: [
      {
        text: "¿Cómo percibes tu piel?",
        type: "radio",
        options: [
          {
            text: "Seca",
            value:
              "[hidroperpetual, skin-filler, serum-skinfiller, aclarative, serum-aclarante, detox, all-in-one]/[nutricare, aclaractive]",
            image:
              "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/PIEL-SECA.png?v=1663592903",
          },
          {
            text: "Mixta",
            value:
              "[hidroperpetual, skin-filler, serum-skinfiller, aclarative, serum-aclarante, detox, all-in-one, gel-hidratante-watermelon, gel-hidratante-tangerine, gel-hidratante-goji, gel-limpieza-watermelon, gel-limpieza-tangerine, gel-limpieza-goji]/[nutricare, aclaractive, antioxidante]",
            image:
              "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/PIEL-MIXTA.png?v=1663592903",
          },
          {
            text: "Grasa",
            value:
              "[hidroperpetual, skin-filler, serum-skinfiller, aclarative, serum-aclarante, detox, all-in-one,gel-hidratante-watermelon, gel-hidratante-tangerine, gel-hidratante-goji, gel-limpieza-watermelon, gel-limpieza-tangerine, gel-limpieza-goji]/[aclaractive, antioxidante]",
            image:
              "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/PIEL-GRASA.png?v=1663592904",
          },
        ],
      },
      {
        text: "¿Qué edad tienes?",
        type: "radio",
        options: [
          {
            text: "Menos de 30 años",
            value:
              "[hidroperpetual, skin-filler, serum-skinfiller, aclarative, serum-aclarante, detox, all-in-one, gel-hidratante-watermelon, gel-hidratante-tangerine, gel-hidratante-goji, gel-limpieza-watermelon, gel-limpieza-tangerine, gel-limpieza-goji]/[nutricare, aclaractive]",
          },
          {
            text: "De 31 a 40 años",
            value:
              "[hidroperpetual, aclarative, serum-aclarante, detox, all-in-one]/[nutricare, aclaractive, antioxidante]",
          },
          {
            text: "Más de 41 años",
            value:
              "[hidroperpetual, skin-filler, serum-skinfiller, aclarative, serum-aclarante, detox, all-in-one]/[nutricare, aclaractive, antioxidante]",
          },
        ],
      },
      {
        text: "¿Cuál es la principal preocupación que tienes sobre la piel de tu <strong>rostro</strong>?<br/>Mínimo 1, máximo 3",
        type: "checkbox",
        options: [
          {
            text: "Tirante",
            value: "[hidroperpetual, detox, all-in-one]",
          },
          {
            text: "Resequedad",
            value: "[hidroperpetual, detox, all-in-one]",
          },
          {
            text: "Tono apagado",
            value: "[skin-filler, serum-skinfiller, detox, all-in-one]",
          },
          {
            text: "Arrugas",
            value: "[skin-filler, serum-skinfiller, detox, all-in-one]",
          },
          {
            text: "Falta de firmeza",
            value: "[skin-filler, serum-skinfiller, detox, all-in-one]",
          },
          {
            text: "Manchas",
            value: "[aclarative, serum-aclarante, all-in-one]",
          },
          {
            text: "Tono no uniforme",
            value: "[aclarative, serum-aclarante, all-in-one]",
          },
          {
            text: "Nada, ¡todo me encanta!",
            value:
              "[hidroperpetual, skin-filler, serum-skinfiller, aclarative, serum-aclarante, detox, all-in-one]",
          },
        ],
      },
    ],
  },
  {
    id: "body",
    label: "Cuerpo",
    coverImage:
      "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/BANNER-DIAGNOSTICO-CUERPO_d4dbacd7-3a8b-4c39-b04f-ae8bd82f6c32.jpg?v=1663031771",
    questions: [
      {
        text: "¿Cómo percibes tu piel?",
        type: "radio",
        options: [
          {
            text: "Seca",
            value: "[nutricare, aclaractive]",
            image:
              "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/PIEL-SECA.png?v=1663592903",
          },
          {
            text: "Mixta",
            value: "[nutricare, aclaractive, antioxidante]",
            image:
              "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/PIEL-MIXTA.png?v=1663592903",
          },
          {
            text: "Grasa",
            value: "[aclaractive, antioxidante]",
            image:
              "https://cdn.shopify.com/s/files/1/0657/7668/1210/files/PIEL-GRASA.png?v=1663592904",
          },
        ],
      },
      {
        text: "¿Qué edad tienes?",
        type: "radio",
        options: [
          {
            text: "Menos de 30 años",
            value: "[nutricare, aclaractive]",
          },
          {
            text: "De 31 a 40 años",
            value: "[nutricare, aclaractive, antioxidante]",
          },
          {
            text: "Más de 41 años",
            value: "[nutricare, aclaractive, antioxidante]",
          },
        ],
      },
      {
        text: "¿Cuál es la principal preocupación  que tienes sobre la piel de tu <strong>cuerpo</strong>?<br/>Mínimo 1, máximo 3",
        type: "checkbox",
        options: [
          {
            text: "Resequedad",
            value: "nutricare",
          },
          {
            text: "Irritación",
            value: "nutricare",
          },
          {
            text: "Comezón",
            value: "nutricare",
          },
          {
            text: "Sensible",
            value: "nutricare",
          },
          {
            text: "Tono apagado",
            value: "antioxidante",
          },
          {
            text: "Arrugas",
            value: "antioxidante",
          },
          {
            text: "Falta de firmeza",
            value: "antioxidante",
          },
          {
            text: "Manchas",
            value: "aclaractive",
          },
          {
            text: "Tono no uniforme",
            value: "aclaractive",
          },
          {
            text: "Nada, ¡todo me encanta!",
            value: "nutricare",
          },
        ],
      },
    ],
  },
];

export default App = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState([
    {
      answers: [
        {
          weight: 1,
          values: [],
        },
        {
          weight: 2,
          values: [],
        },
        {
          weight: 0,
          values: [],
        },
      ],
      step: "Cabello",
      numeroResultados: 1,
      dictionary: {
        hidratacion: "shampoo-anti-caida-ultra-hidratacion",
        detox: "shampoo-anti-caida-detox",
        reparacion: "shampoo-anti-caida-reparacion-extrema",
      },
    },
    {
      answers: [
        {
          weight: 2,
          values: [],
        },
        {
          weight: 1,
          values: [],
        },
        {
          weight: 2,
          values: [],
        },
      ],
      step: "Rostro",
      numeroResultados: 10,
      dictionary: {
        hidroperpetual: "crema-para-rostro-hydroperpetual",
        "skin-filler": "crema-para-rostro-skinfiller",
        "serum-skinfiller": "serum-antiarrugas-skinfiller",
        aclarative: "crema-para-rostro-aclarative",
        "serum-aclarante": "serum-aclarante",
        detox: "soluciones-micelares-detox",
        "all-in-one": "soluciones-micelares-bifasico",
        "gel-hidratante-watermelon": "gel-hidratante-facial-aqualicious-watermelon-madness",
        "gel-hidratante-tangerine": "gel-hidratante-facial-aqualicious-tangerine-euphoria",
        "gel-hidratante-goji": "gel-hidratante-facial-aqualicious-goji-berry-frenzy",
        "gel-limpieza-watermelon": "gel-de-limpieza-facial-aqualicious-watermelon-madness",
        "gel-limpieza-tangerine": "gel-de-limpieza-facial-aqualicious-tangerine-euphoria",
        "gel-limpieza-goji": "gel-de-limpieza-facial-aqualicious-goji-berry-frenzy"
      },
    },
    {
      answers: [
        {
          weight: 0,
          values: [],
        },
        {
          weight: 1,
          values: [],
        },
        {
          weight: 2,
          values: [],
        },
      ],
      step: "Cuerpo",
      numeroResultados: 1,
      dictionary: {
        nutricare: "lactobalsamo-crema-corporal-nutricare",
        aclaractive: "lactobalsamo-crema-corporal-aclarative",
        antioxidante: "lactobalsamo-crema-corporal-antioxidante",
      },
    },
  ]);

  const handleBack = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion(currentQuestion - 1);
    } else {
      setCurrentStep(currentStep - 1);
      setCurrentQuestion(steps[currentStep - 1].questions.length - 1);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { type } = steps[currentStep].questions[currentQuestion];
    const form = e.target;
    const formData = new FormData(form);

    const newAnswers = [...answers];

    if (type === "radio") {
      let data = formData.get(`answer-${currentStep}-${currentQuestion}`);

      if (data.includes("/")) {
        let [data1, data2] = data.split("/");
        data1 = data1
          .replace("[", "")
          .replace("]", "")
          .replace(/ /g, "")
          .split(",");
        data2 = data2
          .replace("[", "")
          .replace("]", "")
          .replace(/ /g, "")
          .split(",");
        newAnswers[currentStep].answers[currentQuestion].values = data1;
        newAnswers[currentStep + 1].answers[currentQuestion].values = data2;
      } else if (data.includes("[")) {
        data = data
          .replace("[", "")
          .replace("]", "")
          .replace(/ /g, "")
          .split(",");
        newAnswers[currentStep].answers[currentQuestion].values = data;
      } else {
        newAnswers[currentStep].answers[currentQuestion].values = [data];
      }
    } else {
      let data = formData.getAll(`answer-${currentStep}-${currentQuestion}[]`);

      if (data.length === 0 || data.length > 3) {
        alert("Debes seleccionar mínimo 1 y máximo 3 opciones");
        return;
      }

      data = data.map((item) => {
        if (item.includes("[")) {
          return item
            .replace("[", "")
            .replace("]", "")
            .replace(/ /g, "")
            .split(",");
        } else {
          return item;
        }
      });

      data = data.flat();

      newAnswers[currentStep].answers[currentQuestion].values = data;
    }

    setAnswers(newAnswers);

    if (currentQuestion < steps[currentStep].questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      // jump questions 1 and 2 in body step
      if (currentStep + 1 === 2) {
        setCurrentQuestion(2);
      } else {
        setCurrentQuestion(0);
      }

      setCurrentStep(currentStep + 1);
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderQuestion = (step, question) => {
    let rendered;
    const { text, type, options } = steps[step].questions[question];

    switch (type) {
      case "radio":
        rendered = (
          <>
            <div className="cover">
              <img src={steps[step].coverImage} alt={steps[step].coverImage} />
              <div className="cover_content">
                <h1>Diagnostico {steps[step].label}</h1>
                <p>
                  ¿ESTÁS LISTA PARA ELEVAR TU BELLEZA?
                  <br />
                  Descubre tus necesidades y ¡revela tu ritual natural Blends
                  Botanicare!
                </p>
              </div>
            </div>
            <h2 dangerouslySetInnerHTML={{
              __html: text
            }}></h2>
            <div
              className={`options ${
                options[0].image ? "options-radio" : "options-checkbox"
              }`}
            >
              {options.map((option, index) => (
                <div
                  className="option"
                  key={`answer-${currentStep}-${currentQuestion}-${option.text}`}
                >
                  <label
                    htmlFor={`answer-${currentStep}-${currentQuestion}-${option.text}`}
                  >
                    {option.image && (
                      <img src={option.image} alt={option.text} />
                    )}
                    <input
                      type="radio"
                      name={`answer-${currentStep}-${currentQuestion}`}
                      id={`answer-${currentStep}-${currentQuestion}-${option.text}`}
                      value={option.value}
                      required
                    />
                    <span>{option.text}</span>
                  </label>
                </div>
              ))}
            </div>
          </>
        );
        break;
      case "checkbox":
        rendered = (
          <>
            <div className="cover">
              <img src={steps[step].coverImage} alt={steps[step].coverImage} />
              <div className="cover_content">
                <h1>Diagnostico {steps[step].label}</h1>
                <p>
                  ¿ESTÁS LISTA PARA ELEVAR TU BELLEZA?
                  <br />
                  Descubre tus necesidades y ¡revela tu ritual natural Blends
                  Botanicare!
                </p>
              </div>
            </div>
            <h2 dangerouslySetInnerHTML={{
              __html: text
            }}></h2>
            <div className={`options options-checkbox`}>
              {options.map((option, index) => (
                <label
                  htmlFor={`answer-${currentStep}-${currentQuestion}[]-${option.text}`}
                  key={`answer-${currentStep}-${currentQuestion}[]-${option.text}`}
                >
                  <input
                    type="checkbox"
                    name={`answer-${currentStep}-${currentQuestion}[]`}
                    id={`answer-${currentStep}-${currentQuestion}[]-${option.text}`}
                    value={`${option.value}`}
                  />
                  <span>{option.text}</span>
                </label>
              ))}
            </div>
          </>
        );
        break;
      default:
        break;
    }

    return (
      <motion.div
        className="question"
        initial={{ x: 300, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -300, opacity: 0 }}
      >
        {rendered}
      </motion.div>
    );
  };

  return (
    <form
      className="main-container"
      onSubmit={handleSubmit}
      id={`${currentStep}-${currentQuestion}`}
    >
      <AnimatePresence>
        {currentStep <= steps.length - 1 ? (
          renderQuestion(currentStep, currentQuestion)
        ) : (
          <Results results={answers} />
        )}
      </AnimatePresence>
      <div className="buttons-container">
        <button
          type="button"
          className="Button Button--secondary"
          disabled={currentStep === 0 && currentQuestion === 0}
          onClick={handleBack}
        >
          Anterior
        </button>
        {currentStep <= steps.length - 1 ? (
          <button type="submit" className="Button Button--primary">
            Siguiente
          </button>
        ) : null}
      </div>
    </form>
  );
};
